/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CameraScheduleRule { 
    cameraFormatId?: number;
    cameraScheduleRuleMainTrigger?: CameraScheduleRule.CameraScheduleRuleMainTriggerEnum;
    cameraScheduleRuleType?: CameraScheduleRule.CameraScheduleRuleTypeEnum;
    cycleTime?: number;
    endTime?: string;
    mainTriggerValue?: number;
    onTime?: number;
    pictureInterval?: number;
    ruleOnlyValidInsideVirtualFence?: boolean;
    ruleOnlyValidOnNoProximityState?: boolean;
    ruleOnlyValidOnProximityState?: boolean;
    ruleOnlyValidOutsideVirtualFence?: boolean;
    ruleOnlyValidVitContactState?: boolean;
    ruleOnlyValidVitExpelledState?: boolean;
    ruleOnlyValidVitNoContactState?: boolean;
    ruleOnlyValidVitNotExpelledState?: boolean;
    size?: number;
    startTime?: string;
    videoRecordMode?: number;
}
export namespace CameraScheduleRule {
    export const CameraScheduleRuleMainTriggerEnum = {
        Gps: 'GPS',
        Timer: 'TIMER',
        Vit: 'VIT',
        ProximityPrelimanary: 'PROXIMITY_PRELIMANARY',
        HighActivity: 'HIGH_ACTIVITY'
    } as const;
    export type CameraScheduleRuleMainTriggerEnum = typeof CameraScheduleRuleMainTriggerEnum[keyof typeof CameraScheduleRuleMainTriggerEnum];
    export const CameraScheduleRuleTypeEnum = {
        Picture: 'PICTURE',
        Video: 'VIDEO'
    } as const;
    export type CameraScheduleRuleTypeEnum = typeof CameraScheduleRuleTypeEnum[keyof typeof CameraScheduleRuleTypeEnum];
}


export type CameraScheduleRuleMainTriggerEnum = typeof CameraScheduleRule.CameraScheduleRuleMainTriggerEnum[keyof typeof CameraScheduleRule.CameraScheduleRuleMainTriggerEnum];
